// Angular
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Material library
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';

// Local library
import { DecimalInputDirective, MatNotificationService,
TranslatePipe
} from '@amwager/util';

@Component({
  selector: 'feature-mat-input-amount',
  templateUrl: './input-amount.component.html',
  styleUrls: ['./input-amount.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    MatButtonModule,
    DecimalInputDirective,
    TranslatePipe
  ]
})
export class InputAmountComponent implements OnInit {

  amount!: number;
  minBet!: number;

  constructor(
    private dialogRef: MatDialogRef<InputAmountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificationService: MatNotificationService
  ) {
    this.minBet = data;
  }

  /**
   * Init on load
   * @returns {void}
   */
  ngOnInit() {
    null;
  }

  /**
   * Bet amount and check if the amount is valid
   * @returns {void}
   */
  betAmount(): void {
    if (
      Number(this.amount) < this.minBet || this.amount === undefined
    ) {
      this.notificationService.showSnackbar('Please enter valid amount.','Close');
      return;
    }

    this.dialogRef.close(this.amount);
  }

}
